export default "__VITE_ASSET__BPZKPETm__"